import React from "react";
import Datepicker from "react-datepicker";

export default ({ name, value, className, onChange, isError, min, max }) => {
	return (
		<Datepicker
			id={name}
			name={name}
			dateFormat="dd-MM-yyyy"
			placeholderText="DD-MM-YYYY"
			minDate={min}
			maxDate={max}
			autoComplete="off"
			className={`form-control textbox-kc${isError ? " textbox-kc-error" : ""} ${className}`}
			selected={value}
			onChange={(date) => onChange({ value: date, name })}
		/>
	);
};
